import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { FinancialEntityCalendarContainerModel } from '../../../../../models/aggregates/financial-entity-calendar';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class FinancialEntityCalendarService extends BaseApiPublicLoginTemplateService<FinancialEntityCalendarContainerModel,FinancialEntityCalendarContainerModel,FinancialEntityCalendarContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'entity-calendars/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'entity-calendars/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'entity-calendars/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX;
    this.httpClient = http;
  }
}